
import React from "react";

import RoomCard from "./RoomCard";


const BookingRoomList = ({
  rooms = [],
  offers = [],
  loading = false,
  searching = false,
  onBook,
  onResetFilters,
}) => {

  /* =========================================================
     LOADING
  ========================================================= */

  if (loading || searching) {
    return (
      <section className="be-room-list">

        <div className="be-empty-state">

          <div>
            ⌛
          </div>

          <h3>
            Finding available rooms...
          </h3>

          <p>
            Please wait while we check availability.
          </p>

        </div>

      </section>
    );
  }


  /* =========================================================
     NO ROOMS
  ========================================================= */

  if (!rooms || rooms.length === 0) {
    return (
      <section className="be-room-list">

        <div className="be-empty-state">

          <div>
            ⌂
          </div>

          <h3>
            No rooms found
          </h3>

          <p>
            Try changing your filters to see more
            available rooms.
          </p>

          <button
            type="button"
            onClick={onResetFilters}
          >
            Reset Filters
          </button>

        </div>

      </section>
    );
  }


  /* =========================================================
     ROOM LIST
  ========================================================= */

  return (
    <section className="be-room-list">

      {rooms.map((room) => (
        <RoomCard
          key={
            room.id ||
            room.roomTypeId ||
            room._id
          }

          room={room}

          offers={offers}

          onBook={onBook}
        />
      ))}

    </section>
  );
};


export default BookingRoomList;
